import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

function GridRow({ children, className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div className={cn('grid grid-cols-12 gap-3', className)} {...props}>
            {children}
        </div>
    );
}

export default GridRow;
